<template>
  <div style="text-align: left">
    <div class="mt-3">
      <div class="container">
        <div class="row mt-2">
          <div class="sectionHead">
            {{ title }}
          </div>
          <!-- <img
            src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/bnpl-site-cms-dev/banner-Recovered.jpg"
            style="width: 100%;"
            v-if="visibleBanner"
          /> -->
        </div>
        <div class="row mt-3">
          <Splide :options="category_banner">
            <SplideSlide v-for="items in Banners" :key="items.id">
              <a>
                <img
                  :src="items.Banner_image.url"
                  alt="Sample 1"
                  style="height:95%;width: 100%;border-radius: 16px; rgb(221 11 126 / 34%) 0px 4px 8px 0px;transition: 0.3s;"
                />
              </a>
            </SplideSlide>
          </Splide>
        </div>
        <div v-if="loading" class="loading">
          <br /><br /><br /><br /><br />
          <pulse-loader color="#000000" size="10px"></pulse-loader>
        </div>
        <div class="row mt-1" v-if="loadedData">
          <div
            v-for="merc in mercList1Items"
            :key="merc.id"
            class="post-exit
            item col-6 "
          >
            <div class="product-card">
              <a :href="'/m/merchant/' + merc.id">
                <div class="badge" v-if="isDiscountValid(merc.discountStartDate, merc.discountEndDate)">{{ merc.merchantDiscount }}</div>

                <div class="product-tumb">
                  <img
                    v-if="merc.rectBannerUrl == null"
                    :src="merc.rectBannerLink"
                    alt=""
                    style="height:100%; width:100%;"
                  />
                  <img
                    v-else
                    :src="merc.rectBannerUrl.formats.thumbnail.url"
                    alt=""
                    style="height:100%; width:100%;"
                  />
                </div>
                {{ merc.merchantName }}
              </a>
            </div>
          </div>

          <div
            v-for="merc in mercList2Items"
            :key="merc.id"
            class="post-exit
            item col-6 "
          >
            <div class="product-card">
              <a :href="'/m/merchant/' + merc.id">
                <div class="badge" v-if="isDiscountValid(merc.discountStartDate, merc.discountEndDate)">{{ merc.merchantDiscount }}</div>

                <div class="product-tumb">
                  <img
                    v-if="merc.rectBannerUrl == null"
                    :src="merc.rectBannerLink"
                    alt=""
                    style="height:100%; width:100%;"
                  />
                  <img
                    v-else
                    :src="merc.rectBannerUrl.formats.thumbnail.url"
                    alt=""
                    style="height:100%; width:100%;"
                  />
                </div>
                {{ merc.merchantName }}
              </a>
            </div>
          </div>
          <div v-if="infiniteLoader" class="loading">
            <br /><br /><br /><br /><br />
            <pulse-loader color="#000000" size="10px"></pulse-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ref } from "vue";
// import axios from "axios";

// Interop vue 2 component to vue 3
import toVue3 from "vue-2-3/to-vue-3";
import Vue2 from "vue2";
import * as Vue3 from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Strapi from "../services/strapi-services.js";
import { isDiscountValid } from '../utils/discountUtils';
const strapi = new Strapi();
toVue3.register(Vue2, Vue3);

export default {
  name: "MobCategoryView",
  components: {
    PulseLoader,
  },
  setup() {
    const category_banner = {
      type: "fade",
      rewind: true,
      height: "200px",
      autoplay: true,
      arrows: false,
      pagination: true,
    };

    return { category_banner };
  },
  data() {
    return {
      type: [],
      mercList: [],
      finalId: 0,
      loading: true,
      loadedData: false,
      language: "php",
      Banners: [],
      mercList1: [],
      mercList2: [],
      page: 1,
      itemsPerPage:10,
      infiniteLoader: false
    };
  },
  computed: {
    title() {
      let parameter = this.$route.query.cattype;
      if (parameter === "electronics") return "Electronics & Accessories";
      if (parameter === "mobile") return "Mobile & Accessories";
      if (parameter === "men") return "Men";
      if (parameter === "women") return "Women";
      if (parameter === "appliances") return "Home Appliances";
      if (parameter === "lifestyle") return "Life Style";
      if (parameter === "grocery") return "Grocery & Pets";
      if (parameter === "beauty") return "Health & Beauty";
      if (parameter === "supplements") return "Suppliments";
      if (parameter === "kokofood") return "Koko Food";
      if (parameter === "gaming") return "Gaming";
      if (parameter === "watches") return "Watches & Accessories";
      if (parameter === "footwear") return "Footwear";
      if (parameter === "automotive") return "Automotive";
      if (parameter === "kids") return "Kids & Toys";
      if (parameter === "sports") return "Sports";
      if (parameter === "socialmedia") return "Social Media Merchants";
      if (parameter === "instore") return "InStore Merchants";
      if (parameter === "ecommerce") return "Online Merchants";
      if (parameter === "travel") return "Travel Merchants";
      if(parameter === "arrivals") return "New Arrivals"
      return "Explore Merchants";
    },
    mercList1Items() {
			return this.mercList1.slice(0, [this.page * this.itemsPerPage]);
    },
    mercList2Items() {
			return this.mercList2.slice(0, [this.page * this.itemsPerPage]);
    }
  },
  created() {
    this.getMerchantByCat();

    let urlPara = this.$route.query.cattype;

    this.getCategoryBanner(urlPara);
  },
  mounted() {
    window.addEventListener('scroll', this.loadMore);
  },
  methods: {
    isDiscountValid,
    loadMore() {
      if (!this.mercList.length) {
        this.infiniteLoader == false;
      }else {
        if (!this.infiniteLoader &&
        (this.page == 1 || (window.innerHeight + window.scrollY) >= document.body.offsetHeight*0.9)
        ) {
          this.infiniteLoader = true;
          setTimeout(() => {
            this.page++;
            this.getMerchantByCat();
            this.infiniteLoader = false;
          }, 1000);                
        }
      }
		},
    getMerchantByCat() {
      let parameter = this.$route.query.cattype;
      // let parameter =JSON.stringify(params)
      console.log("__ROUTER_PARAMS :", parameter);

      // let uri = window.location.search.substring(1);
      // let categoryName = new URLSearchParams(uri);

      // let param = categoryName.get("cattype");
      // console.log("__ROUTER_PARAMS :", param);

      strapi
        .getMercListByCat(parameter, this.page, this.itemsPerPage)
        .then((res) => {
          this.mercList = res.data;

          for (let index = 0; index < this.mercList.length; index++) {
            const element = this.mercList[index];

            if(this.mercList[index].merchantDiscount) {
              this.mercList1.push(element)
            } else {
              this.mercList2.push(element)
            }
          }
          console.log("__MERCHANT_LIST1:", this.mercList1)
          console.log("__MERCHANT_LIST2:", this.mercList2)
          
          console.log("__MERCHANT_LIST:", this.mercList);
          this.loading = false;
          this.loadedData = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCategoryBanner(urlPara) {
      let slug = urlPara;
      console.log("BANNER_TAG_PARAMETER__ ", slug);

      strapi
        .getTheCategoryPageBannerByCatName(slug)
        .then((res) => {
          this.Banners = res.data;
          console.log("BANNER_LIST_ :", this.Banners);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.loading {
  margin-left: 10%;
}
.responsive-iframe {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
  text-align: center;
}

.faqHeader {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 22px; */
  color: #393939;
}

.faqText {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding: 5%;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
}

.kokoWebButtons {
  background-color: #022078;
  border: 0;
  height: 50px;
  width: 100%;
  font-weight: bolder;
}

.playicon {
  position: relative;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.stepperHead {
  font-size: 50px;
  font-weight: bolder;
}

.stepperBody {
  font-size: 16px;
}

/* discount amount */

.product-card {
  position: relative;
  box-shadow: 0 2px 7px #dfdfdf;
  background-color: #f8f5f1;
}

.badge {
  font-family: "Lato";
  position: absolute;
  left: 0;
  top: 20px;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 700;
  background: #fafcfa;
  color: #000000;
  /* border-radius: 1px; */
  padding: 3px 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
}

.badge2 {
  font-family: "Lato";
  position: absolute;
  right: 0;
  top: 85px;
  /* text-transform: uppercase; */
  font-size: 9px;
  font-weight: 700;
  background: #000000;
  color: #fff;
  /* border-radius: 1px; */
  padding: 3px 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
}

.product-tumb {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
}

.product-tumb img {
  max-width: 100%;
  max-height: 100%;
}
</style>
